import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography } from "@mui/material";

import HaveQuestions from "../components/HaveQuestions";

const description =
  'Please read this cookie policy ("cookie policy", "policy") carefully before using the Damjourney.com website ("website", "service") operated by DAM Journey LLC ("us", "we", "our").';
const items = [
  {
    title: "What are cookies?",
    description:
      "Cookies are simple text files that are stored on your computer or mobile device by a website's server. Each cookie is unique to your web browser. It will contain some anonymous information such as a unique identifier, website's domain name, and some digits and numbers.",
  },
  {
    title: "What types of cookies do we use?",
    description: "",
  },
  {
    title: "Necessary Cookies",
    description:
      "Necessary Cookies allow us to offer you the best possible experience when accessing and navigating through our website and using its features. For example, these cookies let us recognize that you have created an account and have logged into that account.",
  },

  {
    title: "Functionality Cookies",
    description:
      "Functionality Cookies let us operate the site in accordance with the choices you make. For example, we will recognize your username and remember how you customized the site during future visits.",
  },
  {
    title: "Analytical Cookies",
    description:
      "These cookies enable us and third-party services to collect aggregated data for statistical purposes on how our visitors use the website. These cookies do not contain personal information such as names and email addresses and are used to help us improve your user experience of the website.",
  },
  {
    title: "How to delete cookies?",
    description:
      "If you want to restrict or block the cookies that are set by our website, you can do so through your browser setting. Alternatively, you can visit https://internetcookies.com, which contains comprehensive information on how to do this on a wide variety of browsers and devices. You will find general information about cookies and details on how to delete cookies from your device.",
  },
  {
    title: "Contacting Us",
    description:
      "If you have any questions about this policy or our use of cookies, please contact us at inquiry@damjourney.com.",
  },
];

const CookiePolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Cookie Policy</title>
        <meta name="description" content="Cookie Policy" />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Cookie Policy"
        />
      </Helmet>

      <Box /*sx={{ maxWidth: "1440px" }}*/>
        {/* Banner */}
        <Box
          sx={{
            width: "100%",
            height: {
              xs: 133, // Mobile
              customBreakpoint: 168, // Tablet
              md: 168.6, // Desktop
            },
            px: {
              xs: "24px",
              customBreakpoint: "84px",
              md: "84px",
            },
            py: {
              xs: "48px",
              customBreakpoint: "60px",
              md: "60px",
            },
            background: "linear-gradient(180deg, #0624BE 0%, #2A2177 100%)",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              textAlign: "center",
              fontSize: {
                xs: "2rem",
                customBreakpoint: "2.5rem",
                md: "2.5rem",
              },
              fontWeight: {
                xs: 600,
                customBreakpoint: 700,
                md: 700,
              },
              lineHeight: {
                xs: 1.17,
                customBreakpoint: 1.2,
                md: 1.2,
              },
              letterSpacing: {
                xs: "0px",
                customBreakpoint: "-0.5px",
                md: "-0.5px",
              },
              color: "#ffffff",
            }}
          >
            Cookie Policy
          </Typography>
        </Box>

        {/* Container */}
        <Box
          sx={{
            width: "100%",
            // maxWidth: "1272px",
            mx: "auto",
            px: {
              xs: "16px",
              customBreakpoint: "48px",
              md: "84px",
            },
            py: {
              xs: "16px",
              customBreakpoint: "48px",
              md: "48px",
            },
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            borderBottom: "1px solid #0000001A",
            borderBottomWidth: "1px",
          }}
        >
          {/* Container Card */}
          <Box
            sx={{
              backgroundColor: "#FFF",
              // width: "100%",
              // maxWidth: "1272px",
              // mx: "auto",
              padding: "24px",

              display: "flex",
              flexDirection: "column",

              gap: {
                xs: "24px",
                customBreakpoint: "32px",
                md: "32px",
              },
              boxShadow: "0px 4px 10px 0px #0000001A",
              borderRadius: "16px",
            }}
          >
            {/* Container Description */}
            <Box
              sx={
                {
                  // maxWidth: "850px",
                }
              }
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 500,
                  lineHeight: 1.5,
                  letterSpacing: "0.15px",
                  color: "#00000099",
                  // mb: "16px",
                }}
              >
                {description}
              </Typography>
            </Box>

            {/* Container Items */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // gap: "16px",
                gap: {
                  xs: "24px",
                  customBreakpoint: "32px",
                  md: "32px",
                },
              }}
            >
              {items.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "1.25rem",
                        customBreakpoint: "1.5rem",
                        md: "1.5rem",
                      },
                      fontWeight: {
                        xs: 600,
                        customBreakpoint: 600,
                        md: 600,
                      },
                      lineHeight: {
                        xs: 1.6,
                        customBreakpoint: 1.33,
                        md: 1.33,
                      },
                      letterSpacing: {
                        xs: "0.15px",
                        customBreakpoint: "0px",
                        md: "0px",
                      },
                      color: "#2A2177",
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 400,

                      lineHeight: 1.5,
                      letterSpacing: "0.15px",
                      color: "#00000099",
                    }}
                  >
                    {item.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        {/* have Question */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default CookiePolicyPage;
